import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Video } from "../interfaces/Video";
import { MainLayout } from "../layout/MainLayout";
import { useTranslation } from "react-i18next";
import { handleApiError, safeJsonParse } from "../../utils/api";

export default function VideoTutorials() {
    const { t } = useTranslation();

    const navigate = useNavigate();
    
    const [videoTutorials, setVideoTutorials] = useState<Video[]>([]);

    useEffect(() => {
        const requestOptionsPost = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/video-tutorials', requestOptionsPost)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;
                setVideoTutorials(data);
            });
    }, []);

    return (
        <MainLayout>
            <div className="container-fluid">
                <div className="row">
                    <div className="video-tutorials-container">
                        <h1>{ t("Video tutorials") }</h1>
                        <div className="video-tutorials-table-container">
                            <div className="inner">
                                { videoTutorials.map((f: Video) => {
                                    return(
                                        <div className="video-item" key={ 'video-' + f._id }>
                                            { f.media.length > 0 &&
                                                <div className="video media-item">
                                                    <video controls>
                                                        <source src={ import.meta.env.VITE_API_URL + '/' + f.media[0].path } />
                                                    </video>
                                                </div>
                                            }
                                            <div className="title">
                                                { f.title }
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </MainLayout>);
}